import axios from "axios";
import router from "./router";

// Crear una instancia de axios
const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

// Agregar un interceptor de solicitudes
api.interceptors.request.use((config) => {
  // Obtener el token de autenticación del almacenamiento local
  const token = JSON.parse(localStorage.getItem("access"));
  // Si hay un token, agregarlo a los encabezados de la solicitud
  if (token) {
    config.headers.Authorization = `Bearer ${token.token}`;
  }
  return config;
});

// Interceptor de respuesta - Manejo automático de sesiones inválidas
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Detectar errores de autenticación (401) o permisos (403)
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      // Limpiar localStorage automáticamente
      localStorage.clear();

      // Redirigir al login solo si no estamos ya ahí
      if (router.currentRoute.value.path !== "/login") {
        router.push("/login");
      }
    }

    return Promise.reject(error);
  },
);

export default api;
